import React from 'react';
import { useTranslation } from 'react-i18next';
import { VehicleFeatureTag, Button } from '../atoms';

const AdditionalOptionCard = ({ option, className = "" }) => {
  const { t } = useTranslation();

  return (
    <div className={`bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden hover:shadow-lg transition-all duration-300 ${className}`}>
      <div className="p-6">
        <div className="flex items-start justify-between mb-4">
          <div className="flex-1">
            <h3 className="text-lg font-bold text-gray-900 mb-2">
              {option.title}
            </h3>
            <p className="text-gray-600 text-sm leading-relaxed mb-3">
              {option.description}
            </p>
          </div>
          <div className="text-right ml-4">
            <div className="text-lg font-bold text-green-600">
              {option.price}
            </div>
          </div>
        </div>

        {/* Features */}
        <div className="mb-4">
          <div className="flex flex-wrap gap-2">
            {option.features.map((feature, index) => (
              <VehicleFeatureTag key={index} className="bg-green-50 text-green-700">
                {feature}
              </VehicleFeatureTag>
            ))}
          </div>
        </div>

        <Button 
          variant="outline" 
          size="sm"
          className="w-full border-green-200 text-green-600 hover:bg-green-50"
        >
          {t('common.inquireDetails')}
        </Button>
      </div>
    </div>
  );
};

export default AdditionalOptionCard;
